export default "__VITE_ASSET__92e951b5__"